<style>
    .content {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.5s ease;
    }
  
    .show {
      max-height: 1000px;
      /* Adjust according to your content height */
    }
  </style>
  <div style="background-color:rgb(212 7 38);height: 80px;padding: 0px 10px;">
    <img src="assets/bm2.png" alt="BW" height="70">
  </div>
  <div class="card card-default">
    <form [formGroup]="valForm">
      <div class="card-body p-0" >
        <div class="row">
          <!-- <div class="col-1">
  
        </div> -->
          <div class="col-12 mt-4">
            <h5 style="text-align: center;font-weight: bold;color: darkblue;">TRACK YOUR SHIPMENT </h5>
          </div>
          <!-- <span style="text-align: center;">Enter Your Tracking Number</span><br> -->
          <!-- <div class="row" style="text-align: center;"> -->
          <div class="col-4"></div>
          <div class="col-md-4 mt-2" style="text-align: center;">
            <div class="input-group mb-3">
              <input  type="text" class="form-control"
                style="height: 2.5rem;border: 2px solid darkblue;font-weight: bold;font-size: large;text-align: center;color: red;background-color: ghostwhite;"
                placeholder="Enter Your Tracking Number" aria-label="Recipient's username" formControlName="id"
                aria-describedby="basic-addon2" (keydown.enter)="gethHttp(this.valForm.value.id)">
              <button class="btn btn-danger" [disabled]="spin" (click)="gethHttp(this.valForm.value.id)">
                <i class="fa fa-search" aria-hidden="true"></i>&nbsp;&nbsp;
                <span *ngIf="!spin">Search</span><span *ngIf="spin">Tracking.....</span></button>
              <!-- <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2"></span>
                  </div> -->
            </div>
          </div>
          <!-- </div> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="container mt-3" style="color: red;text-align: center;font-weight: bold;font-size: x-large;">
        {{this.errMsg}}</div>
        <div class="container mt-3" *ngIf="view">
          <div class="row">
            <div class="col-12">
              <table class="table" style="border-collapse: collapse; width: 100%;">
                <tbody>
                  <tr>
                    <label class="text-danger font mt-2" style="font-weight: bold;  border: none;">Bill Number:</label>
                    <td style="border: none; "><b class="font" style="font-weight: bold;">{{ invoicenumber }}</b></td>
                  </tr>
                  <tr>
                    <label class="text-danger font mt-2" style="font-weight: bold;  border: none;">Invoice Date:</label>
                    <td style="border: none; "><b class="font" style="font-weight: bold;">{{ invoiceDate }}</b></td>
                  </tr>
                  <tr>
                    <label class="text-danger font mt-2" style="font-weight: bold;  border: none;">Origin:</label>
                    <td style="border: none; "><b class="font" style="font-weight: bold;">{{ trackingDetails }}</b></td>
                  </tr>
                  <tr>
                    <label class="text-danger font mt-2" style="font-weight: bold;  border: none;">Destination:</label>
                    <td style="border: none; "><b class="font" style="font-weight: bold;">{{ trackingingDestination }}</b></td>
                  </tr>
                  <tr>
                    <label class="text-danger font mt-2" style="font-weight: bold;  border: none;">Shipment No:</label>
                    <td style="border: none; "><b class="font" style="font-weight: bold;">{{ ShipmentNo }}</b></td>
                  </tr>
                  <tr>
                    <label class="text-danger font mt-2" style="font-weight: bold;  border: none;">Total Pieces:</label>
                    <td style="border: none; "><b class="font" style="font-weight: bold;">{{ trackingingPcs }}</b></td>
                  </tr>
                  <tr>
                    <label class="text-danger font mt-2" style="font-weight: bold;  border: none;">Total Weight:</label>
                    <td style="border: none; "><b class="font" style="font-weight: bold;">{{ trackingingWeight }}</b></td>
                  </tr>
                </tbody>
              </table>
              
              
              
              <div class="current-status">
                <p><strong>Current Status:</strong> {{ trackingLocation1 }} <span style="cursor: pointer;" (click)="DownloadPod()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg><span style="font-size: 16px;">VIEW</span></span></p>
              </div>
            </div>
          </div>
        </div>
        
        
  
  
      <div class="container" *ngIf="view">
        <div class="row">
          <div class="shipment-container ">
            <div class="point-container">
              <div class="dort shipment_pick_up"></div>
              <div class="point-label">Shipment Booking</div>
            </div>
            <div class="point-container">
              <div class="dort departed_to"></div>
              <div class="point-label">Departed</div>
            </div>
            <div class="point-container">
              <div class="dort in_transit"></div>
              <div class="point-label">In Transit</div>
            </div>
            <div class="point-container">
              <div class="dort Destination_Arrived"></div>
              <div class="point-label">Destination Arrived</div>
            </div>
            <div class="point-container">
              <div class="dort Out_For_Delivery"></div>
              <div class="point-label">Out For Delivery</div>
            </div>
            <div class="point-container">
              <div class="dort delivered"></div>
              <div class="point-label">Delivered</div>
            </div>
            <div class="line2"></div>
  
            <div class="line" [ngStyle]="getLineStyle()"></div>
            <span class="icon text-danger bg-light" [ngStyle]="getIconStyle()"> <i
                class=" fa-solid fa-chevron-right"></i></span>
  
          </div>
  
        </div>
      </div>
  
      <!-- <div class="container mt-5">
    <div class="row">
      <div class="col-6 text-center">
          <div>FROM</div>
          <span class="text-danger">Dont Know</span>
      </div>
      <div class="col-6 text-center">
        <div>To</div>
        <span class="text-danger">India, TELENGANA</span>
    </div>
    </div>
  </div> -->
      <div class="container" *ngIf="view">
        <div class="row mt-1 mt-md-5">
          <div class="card w-100  shadow bg-white rounded" style="padding: 10px;font-weight: bold;color: red;"
            (click)="toggle()">All Shipment Updates</div>
          <div [ngClass]="{'show': toggleButton}" class="container content">
            <div class="row">
              <!-- <div class="col-4 shadow p-3 mb-5 bg-white rounded" >
             <div class="row d-flex align-items-center justify-content-center">
              <h6 class="">Track Your Shipment Here</h6>
             </div>
             <div class="row">
              <div class="col-6">
                <div class="border border-dark px-5 py-1" style="border-radius: 4px;">fdfdfd</div>
              </div>
              <div class="col-6">
                <button style="border-radius: 4px;border: none;" class="bg-success px-5 py-1 text-white">Search</button>
              </div>
             </div>
             <div class="row">
              <div class="col-12">
                <table>
                  <thead>
                       <tr>
                        <th>DELIVERY STATUS</th>
                       </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Current Status</td>
                      <td></td>
                    </tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
                    <tr></tr>
  
                  </tbody>
                </table>
              </div>
             </div>
          </div> -->
              <div class="col border d-flex align-items-center justify-content-center">
                <div class="container mt-5 ">
                  <ng-container *ngFor="let item1 of track1; let item2 of track2;let last = last;let i=index">
                    <div class="row ml-5">
                      <div class="col-4 mt-1 text-center">
                        <div class="row" style="font-size: 13px; display: flex;align-items: end;justify-content: end;">
                          {{item2.Transit_Date}}</div>
                        <div class="row" style="font-size: 13px; display: flex;align-items: end;justify-content: end;">
                          {{item2.ScanTime}}</div>
                      </div>
                      <div class="col-3">
                        <div class="container1">
                          <span class="circles">
                            <i class="fa-solid fa-truck-fast"></i>
                          </span>
                          <!-- Add a vertical line between circles -->
                          <span class="vertical-line" *ngIf="!last"></span>
                        </div>
                      </div>
                      <div class="col-5 justify-content-end">
                        <div class="row " style="font-size: 13px; font-weight: 700;">{{item2.track_status}}</div>
                        <!-- <div class="row" style="font-size: 13px;">{{item2.Ctn_Status}}</div> -->
                        <div class="row" style="font-size: 13px;">{{item2.Origin}} - {{item2.Destination}}</div>
                        <div class="row" style="font-size: 13px;">Carton_no: {{item2.Carton_No}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Button to trigger modal -->


<!-- Modal -->
<div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">POD</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img [src]="podUrl" alt="Modal Image" class="img-fluid" style="animation: fadeIn 1s;">
      </div>
    </div>
  </div>
</div>
